import SectionItemContent from "./SectionItemContent";
import SectionItemSubtitle from "./SectionItemSubtitle";
import SectionItemTitle from "./SectionItemTitle";

const SectionItem = ({ title, subtitle, content, titleActions = null, overrideStyles }) => {
  return (
    <div className="flex flex-col w-full lg:w-4/5 gap-6">
      <div className="flex gap-4">
        <div className="flex flex-col w-full">
          <SectionItemTitle title={title} />
          <SectionItemSubtitle subtitle={subtitle} />
        </div>
        {titleActions && <>{titleActions}</>}
      </div>
      <SectionItemContent content={content} />
    </div>
  );
};

export default SectionItem;
